import {Component, HostListener, Inject, Input, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {Subject} from "rxjs/index";
import {BsModalRef} from 'ngx-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';
import {TimelineService} from "@app/shared/services/timeline.service";
import {environment} from "../../../../environments/environment";
import {TABLETYPES} from "@app/config";
import {HttpClient} from "@angular/common/http";
import {GetV5CoreApiUrl} from "@app/utils/get-v5-core-api-url";
import {GetApiUrl, GetSelect2FileTagsOptions} from "@app/utils";
import {GetJobApiUrl} from "@app/utils/get-job-api-url";

declare var $: any;
@Component({
    selector: 'app-view-attach-file',
    templateUrl: './view-attach-files.component.html',
    styleUrls: ['./view-attach-files.component.scss'],
    styles: []
})
export class ViewAttachFilesComponent implements OnInit, AfterViewInit {
    public onClose: Subject<boolean>;
    previewableImageTypes: Array<string> = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    previewableVideoTypes: Array<string> = ['mp4', 'webm', 'ogg', 'ogv', 'm4v'];
    data: any;
    createdDetails: any;
    Url: any;
    filesArray: any;
    index: any;
    clone: any;
    enableEmail: boolean;
    tagsSelect2Config: any;
    action='';
    selectedTags = [];
    isTagUpdated: boolean= false;
    showTagDropDown: boolean= false;
    mode = '';

    @ViewChild('select2EditFileTags') select2FileTags: ElementRef;
    constructor(private ts: TimelineService,
                public bsModalRef: BsModalRef,
                private sanitizer: DomSanitizer,
                private http: HttpClient,
                private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.filesArray;
        this.clone;
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.clone.fileLocation);
        this.onClose = new Subject();
        this.clone['createdDateTime'] = this.ts.convertTimeLineDateTime(this.clone['createdDateTime']);
        if(this.showTagDropDown) {
            this.tagsSelect2Config = GetSelect2FileTagsOptions();
        }
    }
    ngAfterViewInit () {
        if(this.showTagDropDown) {
            if (this.clone.hasOwnProperty('tags') && this.clone.tags.length) {
                this.tagsSelect2Config['data'] = this.clone.tags;
                $(this.select2FileTags.nativeElement).select2('data', this.clone.tags);
            }
        }
    }
    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode == 39 || event.keyCode == 40) { //right and down key
            this.fileRightArrow();
        }
        else if (event.keyCode == 37 || event.keyCode == 38) { //left and up key
            this.fileLeftArrow();
        }
    }

    fileRightArrow() {
        if (this.filesArray.length > 0 && this.filesArray.length - 1 > this.index) {
            this.index++;
            this.selectedIndex(this.index)
        }
    }

    fileLeftArrow() {
        if (this.filesArray.length > 0 && this.index > 0) {
            this.index--;
            this.selectedIndex(this.index)
        }
    }

    selectedIndex(currentIndex) {
        if (this.filesArray[currentIndex]) {
            const findNextImage = this.filesArray[currentIndex];
            this.clone = {
                ...this.clone,
                ...findNextImage,
                createdDateTime: this.ts.convertTimeLineDateTime(findNextImage['createdDateTime'])
            };
            this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(findNextImage['fileLocation']);
            this.cdr.detectChanges();
        }
    }
    async attachFileDownload(imageSrc) {
        const image = await fetch(imageSrc);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = this.clone.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    selectedTag(tag) {
       this.selectedTags = tag;
       this.isTagUpdated = true;
    }

    save() {
        this.action = 'saving';
        let postParams = {};
        if (this.isTagUpdated) {
            const formData = new FormData();
            this.selectedTags.forEach((tag: number) => {
                formData.append('tags[]', tag.toString());
            });
            this.http.post(
                GetJobApiUrl('e5ec7051/addEditFileTags'),
                {tags: this.selectedTags, tableType: TABLETYPES.ATTACHED_FILES, fileId :  this.clone['attachedId'] }
            ).subscribe((res: any) => {
                this.onClose.next();
                this.bsModalRef.hide();
            }, (error: any) => {
                this.action = '';
            }, () => {
                this.action = '';
            });
        } else {
            this.bsModalRef.hide();
        }
    }
    openSidePanel(type) {
        if (type == 'email') {
            type = this.clone;
        }
        this.onClose.next(type);
        this.bsModalRef.hide();
    }

    public updateFileData(newData: any) {
        this.clone = {
            ...newData,
            createdDateTime: this.ts.convertTimeLineDateTime(newData['createdDateTime'])
        };
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.clone.fileLocation);
        this.cdr.detectChanges();
        // if (this.clone.hasOwnProperty('tags') && this.clone.tags.length) {
        //     this.tagsSelect2Config['data'] = this.clone.tags;
        //     $(this.select2FileTags.nativeElement).select2('data', this.clone.tags);
        // } else {
        //     this.tagsSelect2Config['data'] = [];
        //     $(this.select2FileTags.nativeElement)
        //         .val(null)
        //         .trigger('change');  // notify Select2 to refresh UI
        // }
    }

    isPreviewableImage(file): boolean {
        const fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        return this.previewableImageTypes.indexOf(fileType) !== -1;
    }

    isPreviewableVideo(file): boolean {
        const fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        return this.previewableVideoTypes.indexOf(fileType) !== -1;
    }

    getVideoMimeType(file): string {
        const fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';

        if (fileType === 'mp4' || fileType === 'm4v') {
            return 'video/mp4';
        }

        if (fileType === 'webm') {
            return 'video/webm';
        }

        if (fileType === 'ogg' || fileType === 'ogv') {
            return 'video/ogg';
        }

        return 'video/mp4';
    }

    isNoPreviewDocument(file): boolean {
        const rawFileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';

        if (!rawFileType) {
            return false;
        }

        return rawFileType === 'xls'
            || rawFileType === 'xlsx'
            || rawFileType === 'csv'
            || rawFileType === 'xml'
            || rawFileType === 'text/xml'
            || rawFileType === 'application/xml';
    }

}
